import { Nav, Tab } from "react-bootstrap";
import { IComplianceInvestigationDetails } from "../../../api/IComplianceInvestigation";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import { ComplaintsGrid } from "../../../leap-components/Complaint/ComplaintsGrid";
import { ComplianceInvestigationActionsInstructionsGrid } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationActionsInstructionsGrid";
import { ComplianceInvestigationEffectsGrid } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationEffectsGrid";
import { ComplianceInvestigationLikelyCausesGrid } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationLikelyCausesGrid";
import { ComplianceInvestigationOutcomesGrid } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationOutcomesGrid";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";
import { IncidentsGrid } from "../../../leap-components/Incidents/IncidentsGrid";
import { LicenseeReturnsGrid } from "../../../leap-components/LicenseeReturns/LicenseeReturnsGrid";
import { NonCompliancesGrid } from "../../../leap-components/NonCompliances/NonCompliancesGrid";
import { SiteVisitsGrid } from "../../../leap-components/SiteVisits/SiteVisitsGrid";
import { SiteVisitRegardingObjectTypes } from "../../../leap-components/SiteVisits/SiteVisitsGridProps";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  complianceInvestigation: IComplianceInvestigationDetails;
  licenceProfile: ILicenceProfile;
}

interface ComplianceInvestigationProps {
  complianceInvestigation: IComplianceInvestigationDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  complianceInvestigation,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="actions-instructions">
            Actions / Instructions
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="causes">Likely Causes</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="effects">Effects</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="outcomes">Outcomes</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="non-compliances">Non Compliances</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="complaints">Complaints</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="incidents">Incidents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="lr">Licensee Returns</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="site-visits">Site Visits</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="actions-instructions">
          <ComplianceInvestigationActionsInstructionsGrid
            complianceInvestigationId={
              complianceInvestigation.complianceinvestigationid
            }
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="causes">
          <ComplianceInvestigationLikelyCausesGrid
            complianceInvestigationId={
              complianceInvestigation.complianceinvestigationid
            }
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="effects">
          <ComplianceInvestigationEffectsGrid
            complianceInvestigationId={
              complianceInvestigation.complianceinvestigationid
            }
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="outcomes">
          <ComplianceInvestigationOutcomesGrid
            complianceInvestigationId={
              complianceInvestigation.complianceinvestigationid
            }
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={
              complianceInvestigation.complianceinvestigationid
            }
          />
        </Tab.Pane>
        <Tab.Pane eventKey="non-compliances">
          <NonCompliancesGrid
            relatedRecordType="Compliance Investigation"
            relatedRecordId={complianceInvestigation.complianceinvestigationid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="lr">
          <LicenseeReturnsGrid
            relatedRecordType="CI"
            relatedrecordId={complianceInvestigation.complianceinvestigationid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="site-visits">
          <SiteVisitsGrid
            regardingObjectType={SiteVisitRegardingObjectTypes.CI}
            regardingObjectId={
              complianceInvestigation.complianceinvestigationid
            }
          />
        </Tab.Pane>
        <Tab.Pane eventKey="complaints">
          <ComplaintsGrid
            relatedRecordType={"CI"}
            relatedrecordId={complianceInvestigation.complianceinvestigationid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="incidents">
          <IncidentsGrid
            relatedRecordType={"CI"}
            relatedrecordId={complianceInvestigation.complianceinvestigationid}
            licenceProfile={licenceProfile}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  complianceInvestigation,
  licenceProfile,
}: ComplianceInvestigationProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="actions-instructions"
      complianceInvestigation={complianceInvestigation}
      licenceProfile={licenceProfile}
    />
  );
  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
